export enum FareType {
  Distance = 'DISTANCE',
  GeoZone = 'GEO_ZONE',
  Radius = 'RADIUS',
  ZipCode = 'ZIP_CODE',
}

export const FareTypeDisplayName = {
  [FareType.Distance]: 'Distance',
  [FareType.GeoZone]: 'Geo zone',
  [FareType.Radius]: 'Radius',
  [FareType.ZipCode]: 'Zip code',
};
